import React from 'react';
import { useParams } from 'react-router-dom';
import { Layout } from 'antd';
import DashboardSettings from '../settings/DashboardSettings';

const { Content } = Layout;


export default function DashboardSettingsPage() {
    const { section } = useParams<{ section?: string }>();
    return (
        <Content className="general-layout-content">
            <DashboardSettings section={section} />
        </Content>
    );
}
